import * as React from 'react';

type Props = {
  label: React.ReactNode;
  /** The control's id, so the label names it. */
  htmlFor?: string;
  children: React.ReactNode;
};
const InputGroup = (props: Props) => {
  return (
    <div className="flex flex-row items-start gap-2">
      {/* pt-1.5 aligns the label with the first line of an h-9 input, so
          multi-line controls (e.g. tags & fields) don't center the label */}
      <label htmlFor={props.htmlFor} className="text-muted-foreground w-30 shrink-0 pt-1.5">
        {props.label}
      </label>
      {/* min-w-0 so long unbroken content (e.g. raw bank descriptors) shrinks
          the field instead of pushing the row past its container */}
      <div className="min-w-0 flex-1">{props.children}</div>
    </div>
  );
};

export default InputGroup;
